import { createElement } from 'react';
import './index.scss';
import { Collapse } from '@alifd/next';
const AccordionSelector = ({ dataList, children, ...otherProps }) => {
    console.log(dataList, children);
    const _otherProps = otherProps || {};
    return (createElement(Collapse, { className: "accordion-selector", ..._otherProps }, children));
};
AccordionSelector.Item = Collapse.Panel;
AccordionSelector.Item.displayName = 'AccordionSelector.Item';
AccordionSelector.displayName = 'AccordionSelector';
export default AccordionSelector;
